/**
 * JSON Viewer Pro — pretty-prints JSON responses in the browser
 *
 * Exposes a single web-accessible-resource group matched to http(s), ftp and file
 * origins with no `use_dynamic_url`, holding seven static files including
 * `images/icons/bell.svg`, `js/main.js` and several themed stylesheets. All are
 * reachable from any page at a fixed URL.
 *
 * The bell icon is the primary signal — an image, so it loads through `probeImage`
 * with no CORS grant and survives a strict page CSP. The themed stylesheet and main
 * bundle corroborate.
 *
 * Manifest verified against version 1.0.6.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'eifflpmocdbdmepbjaopkkhbfmdgijcc';

export const jsonViewerPro: ExtensionDefinition = {
  id: ID,
  name: 'JSON Viewer Pro',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 300_000,
  notes:
    'Seven static WAR on http(s)/ftp/file origins with no dynamic URL. Loading the ' +
    'bell.svg icon is conclusive and needs no CORS grant; the CSS and JS corroborate.',
  signals: [
    {
      id: 'war-bell-svg',
      kind: 'web-accessible-resource',
      description:
        'Load images/icons/bell.svg via <img> — a bundled icon exposed to every http(s) ' +
        'origin; needs no CORS grant, so it works even under a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'images/icons/bell.svg'),
    },
    {
      id: 'war-dark-pro-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch css/color-themes/dark-pro.css — a vendor-named theme stylesheet, ' +
        'independent of the icon path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'css/color-themes/dark-pro.css'),
    },
    {
      id: 'war-main-js',
      kind: 'web-accessible-resource',
      description: 'Fetch js/main.js — the main bundle, a third path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'js/main.js'),
    },
  ],
};
